var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropdown",
      class: { "is-active": _vm.isExpanded },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          _vm.isExpanded = false
        }
      }
    },
    [
      _c("div", { staticClass: "dropdown-trigger" }, [
        _c(
          "button",
          {
            staticClass: "button is-small font-semibold whitespace-normal",
            class: { "is-outlined is-success": _vm.type === "scheduled" },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.isExpanded = !_vm.isExpanded
              }
            }
          },
          [
            _vm.type === "scheduled"
              ? _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-w-14 mr-2",
                    attrs: { "aria-hidden": "true", role: "img" }
                  },
                  [
                    _c("use", {
                      attrs: { "xlink:href": "#icon-calendar-check" }
                    })
                  ]
                )
              : _vm.type === "from" || _vm.type === "unavailable"
              ? _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-w-14 mr-2",
                    attrs: { "aria-hidden": "true", role: "img" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-reply" } })]
                )
              : _vm.type === "to"
              ? _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-w-14 mr-2",
                    attrs: { "aria-hidden": "true", role: "img" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-hourglass" } })]
                )
              : _vm._e(),
            _vm._v(
              "\n\n      " +
                _vm._s(
                  _vm.meetingSuites[_vm.suiteId]
                    ? _vm.getCompanySuiteName(
                        _vm.meetingSuites[_vm.suiteId].name,
                        _vm.meetingSuites[_vm.suiteId].company.name
                      )
                    : ""
                ) +
                "\n\n      "
            ),
            _vm.type == "scheduled" || _vm.isSuiteWriteable
              ? _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-w-14 ml-2",
                    attrs: { "aria-hidden": "true", role: "img" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-angle-down" } })]
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _vm.isExpanded
        ? _c("div", { staticClass: "dropdown-menu" }, [
            _vm.isSuiteWriteable || _vm.type === "scheduled"
              ? _c("div", { staticClass: "dropdown-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-item is-size-7 has-text-centered"
                    },
                    [
                      _vm.type === "from"
                        ? _c("b", [_vm._v("Awaiting your response")])
                        : _vm.type === "scheduled"
                        ? _c("b", [_vm._v("Appointment is scheduled")])
                        : _vm.type === "to"
                        ? _c("b", [_vm._v("Waiting for approval")])
                        : _vm.type === "unavailable"
                        ? _c("b", [_vm._v("Appointment no longer available")])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.timeslot.is_open && _vm.type === "from"
                    ? _c("div", { staticClass: "dropdown-item" }, [
                        _vm.type === "from"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "button is-fullwidth is-small is-primary is-outlined",
                                attrs: { type: "button" },
                                on: { click: _vm.approve }
                              },
                              [
                                _vm.type === "scheduled"
                                  ? _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "svg-inline--fa fa-w-14 mr-2",
                                        attrs: {
                                          "aria-hidden": "true",
                                          role: "img"
                                        }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#icon-check-circle"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v("Approve")])
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "scheduled"
                    ? _c("div", { staticClass: "dropdown-item" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-fullwidth is-small is-info is-outlined",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.showAddToCalendar = !_vm.showAddToCalendar
                              }
                            }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "svg-inline--fa fa-w-14 mr-2",
                                attrs: { "aria-hidden": "true", role: "img" }
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-calendar-alt" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown" }, [
                              _c("div", { staticClass: "dropdown-trigger" }, [
                                _vm._v(
                                  "\n              Add To Calendar\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.showAddToCalendar
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu  calendar-actions"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button is-fullwidth",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "addToCalendar",
                                                        "ical"
                                                      )
                                                      _vm.isExpanded = !_vm.isExpanded
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._m(0),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v("iCalendar")
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button is-fullwidth",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "addToCalendar",
                                                        "outlook"
                                                      )
                                                      _vm.isExpanded = !_vm.isExpanded
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._m(1),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v("Outlook")
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button is-fullwidth",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "addToCalendar",
                                                        "google"
                                                      )
                                                      _vm.isExpanded = !_vm.isExpanded
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._m(2),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v("Google")])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button is-fullwidth",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "addToCalendar",
                                                        "yahoo"
                                                      )
                                                      _vm.isExpanded = !_vm.isExpanded
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._m(3),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v("Yahoo")])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-item" }, [
                    _vm.type === "from" || _vm.type === "unavailable"
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "button is-fullwidth is-small is-danger is-outlined",
                            attrs: { type: "button" },
                            on: { click: _vm.cancel }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "svg-inline--fa fa-w-14 mr-2",
                                attrs: { "aria-hidden": "true", role: "img" }
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-times-circle" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Decline/Reschedule")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "scheduled" && _vm.isSuiteWriteable
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "button is-fullwidth is-small is-danger is-outlined",
                            attrs: { type: "button" },
                            on: { click: _vm.cancel }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "svg-inline--fa fa-w-14 mr-2",
                                attrs: { "aria-hidden": "true", role: "img" }
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-times-circle" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Cancel/Reschedule")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "to"
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "button is-fullwidth is-small is-primary is-outlined",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "ExhibitorSchedule",
                                  params: {
                                    id: _vm.meetingId,
                                    suiteId: _vm.suiteId
                                  }
                                })
                              }
                            }
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "svg-inline--fa fa-w-14 mr-2",
                                attrs: { "aria-hidden": "true", role: "img" }
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-arrow-right" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Navigate to schedule")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "scheduled" && _vm.user.isAdmin
                      ? _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("Add Guest")
                            ]),
                            _vm._v(" "),
                            !_vm.registrations.length
                              ? _c("span", [
                                  _vm._v(
                                    "Could not load meeting registrations. Your MatrixMaxx session may\n            be expired. Please login and reload the page."
                                  )
                                ])
                              : [
                                  _c("multiselect", {
                                    attrs: {
                                      options: _vm.registrations,
                                      searchable: true,
                                      label: "display",
                                      "track-by": "id",
                                      placeholder:
                                        "Start typing to search users",
                                      selectLabel: ""
                                    },
                                    on: { select: _vm.addGuest }
                                  })
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "far fa-calendar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fab fa-microsoft" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fab fa-google" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fab fa-yahoo" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-612f5e88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-612f5e88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AppointmentActions.vue
// module id = null
// module chunks = 